const API_KEY = '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';

export const generateAIResponse = async (prompt) => {
  try {
    console.log('Sending request to OpenAI...'); // Debug log
    
    const response = await fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${API_KEY}`
      },
      body: JSON.stringify({
        model: "gpt-4o-mini",
        store: true,
        messages: [
          { role: "user", content: prompt }
        ]
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`API Error: ${errorData.error?.message || response.statusText}`);
    }

    const data = await response.json();
    console.log('Response received:', data); // Debug log
    
    return data.choices[0].message.content;
    
  } catch (error) {
    console.error('Detailed error:', {
      message: error.message,
      status: error.status,
      response: error.response
    });
    throw error;
  }
}; 